import { ITypeSvg } from '@/types/bs-types/svg';

export default function Cross({ color = '#8A97A3', size = 32, onClick }: ITypeSvg): JSX.Element {
  return (
    <svg width={`${size}`} height={`${size}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
      <path
        d="M16.3527 17.1202L15.9992 16.7685L15.6465 17.1211L10.8213 21.9463C10.7189 22.0488 10.6105 22.0921 10.4649 22.0881C10.309 22.0831 10.1885 22.0308 10.0788 21.9211C9.97566 21.818 9.92528 21.7009 9.92528 21.5379C9.92528 21.3737 9.97594 21.2563 10.0788 21.1535L14.8788 16.3535L15.2324 15.9999L14.8788 15.6463L10.0536 10.8211C9.95415 10.7217 9.90767 10.6105 9.91188 10.4523C9.9171 10.2833 9.97228 10.16 10.0788 10.0535C10.182 9.95028 10.2991 9.8999 10.4621 9.8999C10.6261 9.8999 10.7433 9.95043 10.8461 10.0531C10.8463 10.0532 10.8464 10.0533 10.8465 10.0535L15.6456 14.8777L15.9992 15.2331L16.3536 14.8787L21.1788 10.0535C21.282 9.95028 21.3991 9.8999 21.5621 9.8999C21.7263 9.8999 21.8436 9.95056 21.9465 10.0535C22.0494 10.1563 22.1001 10.2737 22.1001 10.4379C22.1001 10.6009 22.0497 10.718 21.9465 10.8211L17.1213 15.6463L16.7678 15.9999L17.1213 16.3535L21.9465 21.1787C22.0526 21.2848 22.1001 21.3991 22.1001 21.5499C22.1001 21.7007 22.0526 21.8151 21.9465 21.9211C21.8436 22.024 21.7263 22.0747 21.5621 22.0747C21.3991 22.0747 21.282 22.0243 21.1788 21.9211L21.1779 21.9202L16.3527 17.1202Z"
        fill={color}
        stroke={color}
      />

      <defs>
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z"
          fill="white"
        />
      </defs>
    </svg>
  );
}
